export default {

    extractPhoneFields: function (phone, numberCodes, countryCode) {

        phone = phone.trim();
        var phoneFields = {
            countryCode: "",
            area: "",
            phone: "",
            isValid: false,
            isUAE: false,
            e164: "",
            rawPhone: phone,
            phoneLength: 0
        }

        if (phone.startsWith("00")) {
            phone = phone.substring(2, phone.length);
        } else if (phone.startsWith("+")) {
            phone = phone.substring(1, phone.length);
        }

        if (phone.charAt(0) == "0") {
            phone = phone.substring(1, phone.length);
        }

        if (phone.length == 9  && !phone.startsWith("971") && !countryCode) {
            // 8 or 9 digit UAE number
            phoneFields.phoneLength = phone.length;
            phoneFields.countryCode = "971";
            phoneFields.area = phone.substring(0, 2);
            phoneFields.phone = phone.substring(2, phone.length);
            phoneFields.isUAE = true;
            phoneFields.isValid = true;
            phoneFields.e164 = "+" + phoneFields.countryCode + phoneFields.area + phoneFields.phone;
        } else if (phone.length >= 12 && phone.length <= 12 && phone.startsWith("971")) {
            // 12 or 13 digit UAE number 971521234567
            phoneFields.phoneLength = phone.length;
            phoneFields.countryCode = phone.substring(0, 3);
            phoneFields.area = phone.substring(3, 5);
            phoneFields.phone = phone.substring(5, phone.length);
            phoneFields.isUAE = true;
            phoneFields.isValid = true;
            phoneFields.e164 = "+" + phoneFields.countryCode + phoneFields.area + phoneFields.phone;
        } else if (((phone.length >= 9 && phone.length <= 12 && !countryCode)) || ((countryCode && phone.substring(countryCode.length, phone.length).length >= 9 && phone.substring(countryCode.length, phone.length).length <= 12)) && !phone.startsWith("971")) {

            // non UAE number
            phoneFields.phoneLength = phone.length;
            phoneFields.isUAE = false;
            var i = 0;
            for (i = 0; i < numberCodes.length; i++) {
                if (phone.startsWith(numberCodes[i].countryCode)) {
                    phoneFields.countryCode = numberCodes[i].countryCode;
                    phoneFields.phone = phone.substring(numberCodes[i].countryCode.length, phone.length);
                    phoneFields.area = "";
                    phoneFields.e164 = "+" + phoneFields.countryCode + phoneFields.area + phoneFields.phone;
                    phoneFields.isValid = true;
                    break;
                }
            }

            if (phoneFields.isValid == false) {
                phoneFields.countryCode = "";
                phoneFields.phone = phone;
                phoneFields.area = "";
                phoneFields.e164 = "+" + phoneFields.countryCode + phoneFields.area + phoneFields.phone;
                phoneFields.isValid = true;
            }

        } else {
            // invalid number
            phoneFields.isValid = false;
        }
        return phoneFields;

    },

    isNameAndEmailAndPhoneValid: function (custDetails, numberCodes) {
        return this.isNameValid(custDetails.firstName) && this.isEmailValid(custDetails.email) && this.isPhoneValid((custDetails.phone.country === "971"?custDetails.phone.country + custDetails.phone.area + custDetails.phone.number:custDetails.phone.country +  custDetails.phone.number), numberCodes, custDetails.phone.country);
    },

    redirectOnLanguageChange: function() {

    },

    isNameValid: function(name) {
        return name != null && name != 'undefined' && name != '';
    },

    isEmailValid: function(email) {
        if(email != null && email != 'undefined' && email != '') {
            if(this.validEmail(email))
                return true;
        }

        return false;
    },

    validEmail: function (email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },

    isPhoneValid: function(phone, numberCodes, countryCode) {
        return this.extractPhoneFields(phone, numberCodes, countryCode).isValid;
    },



}
